module.exports = __webpack_public_path__ + "img/listMode.321c31bd.svg";